import {baseApi} from './base'
import type {BaseFetchResultsInterface} from '@interfaces/base'
import type {EquipmentTimeWindowInterface} from '@interfaces/equipmentTimeWindowInterface'

const searchAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchForEquipmentTimeWindowBasedOnSignalValue: builder.query<
      EquipmentTimeWindowInterface[],
      {
        value: string
        intervalType?: 'int' | 'string'
        productionAreaId?: string
        lineId?: string
        equipmentId?: string
      }
    >({
      query: ({value, intervalType, productionAreaId, lineId, equipmentId}) => ({
        url: 'search_for_equipment_time_window_based_on_signal_value/',
        params: {
          value,
          ...(intervalType ? {interval_type: intervalType} : {}),
          ...(productionAreaId ? {production_area: productionAreaId} : {}),
          ...(lineId ? {machine: lineId} : {}),
          ...(equipmentId ? {machine_sub_system: equipmentId} : {}),
        },
      }),
      transformResponse: (response: BaseFetchResultsInterface<EquipmentTimeWindowInterface>) =>
        response.results,
      extraOptions: {refetchOnMountOrArgChange: true},
    }),
  }),
  overrideExisting: false,
})

export const {useSearchForEquipmentTimeWindowBasedOnSignalValueQuery} = searchAPI
